import { createTheme } from '@mui/material/styles';

/** 프로토타입(docs/prototype) 톤과 정합 — 네이비/블루 팔레트 */
export const theme = createTheme({
  palette: {
    primary: { main: '#2d7ff9' },
    secondary: { main: '#12b58c' },
    background: { default: '#f4f6fa', paper: '#ffffff' },
    text: { primary: '#1a2433', secondary: '#5a6678' },
    error: { main: '#c0362f' },
    warning: { main: '#f5a623' },
    success: { main: '#12b58c' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"맑은 고딕", "Malgun Gothic", system-ui, sans-serif',
    h1: { fontSize: 26, fontWeight: 800 },
    h2: { fontSize: 18, fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { border: '1px solid #e2e7ef' } }, defaultProps: { elevation: 0 } },
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
